import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=0333a8a2&scoped=true&"
import script from "./Prediction.vue?vue&type=script&lang=js&"
export * from "./Prediction.vue?vue&type=script&lang=js&"
import style0 from "./Prediction.vue?vue&type=style&index=0&id=0333a8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333a8a2",
  null
  
)

export default component.exports